<script>
import resources from './resources'

export default {
  name: 'professional-documents-form',
  mixins: [resources],
  data () {
    return {
      show: true,
      beenUpdated: false,
      wasRaised: false
    }
  }
}
</script>

<template lang="pug">
  page(title="Meus Documentos", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          .col-md-12

          .nav-tabs-wrapper
            ul.nav.nav-tabs.nav-340
              li.active
                a(href="#") Listagem

              li
                router-link(:to="{ name: 'professional.company.documents.index'  }")
                  a(href='#') Documentos
          .col-xs-12.white-bg.wrapper(v-if="loading")
            .row.border-bottom-light
              spinner-professional(:show="true")
          .col-xs-12.white-bg.wrapper(v-if="!loading")
            .row
              .agendamentos.col-xs-12.white-bg
                .row.hidden-xs.hidden-sm
                  .col-xs-12.col-sm-2.col-title Tipo
                  .col-xs-12.col-sm-4.col-title Nome
                  .col-xs-12.col-sm-3.col-title Situação
                  .col-xs-12.col-sm-3.col-title.text-center Atividades
                .order-by.hidden-md.hidden-lg
                .row
                  ul
                    li(style="padding: 10px 10px 10px", v-for="document in documents")
                      .general
                        .col-xs-11.col-xs-offset-1.col-sm-4.col-sm-offset-0.col-md-2.col-md-offset-0
                          small.grey
                          strong.is-required(v-if="document.required === 1") {{ document.slug }}
                          strong.dont-required(v-if="document.required === 0") {{ document.slug }}

                        .col-xs-11.col-xs-offset-1.col-sm-4.col-sm-offset-0.col-md-4.col-md-offset-0
                          small.grey
                          strong.is-required(v-if="document.required === 1") {{ document.label }}
                          strong.dont-required(v-if="document.required === 0") {{ document.label }}

                        .col-xs-10.col-sm-3.col-md-3
                          small.grey
                          strong.is-required(v-if="document.required === 1") {{ document.document_status }}
                          strong.dont-required(v-if="document.required === 0") {{ document.document_status }}

                        .col-xs-11.col-xs-offset-1.col-sm-4.col-sm-offset-0.col-md-3.col-md-offset-0.text-center

                          f-file-document-cart(
                           v-if="!document.attachment.uuid && !document.id && document.slug == 'CART'",
                           v-model="document.attachment",
                           name='attachment',
                           :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                          f-file-document-cpf(
                           v-if="!document.attachment.uuid && !document.id && document.slug == 'CPF'",
                           v-model="document.attachment",
                           name='attachment',
                           :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                          f-file-document-dipl(
                           v-if="!document.attachment.uuid && !document.id && document.slug == 'DIPL'",
                           v-model="document.attachment",
                           name='attachment',
                           :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                          f-file-document-cert(
                           v-if="!document.attachment.uuid && !document.id && document.slug == 'CERT'",
                           v-model="document.attachment",
                           name='attachment',
                           :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                          f-file-document-cend(
                           v-if="!document.attachment.uuid && !document.id && document.slug == 'CEND'",
                           v-model="document.attachment",
                           name='attachment',
                           :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                          f-file-document-cnpj(
                           v-if="!document.attachment.uuid && !document.id && document.slug == 'CNPJ'",
                           v-model="document.attachment",
                           name='attachment',
                           :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                          f-file-document-outr(
                           v-if="!document.attachment.uuid && !document.id && document.slug == 'OUTR'",
                           v-model="document.attachment",
                           name='attachment',
                           :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                          button.btn.save.btn-sm.pull-right(
                            @click.prevent="downloadDocument(document)",
                            type='button',
                            style='margin-top: 0px; margin-bottom: 0px;',
                            v-if='document.id')
                            i.fa.fa-eye

                          button.btn.exclude.btn-sm.pull-right(
                            @click.prevent="doDelete(document)",
                            type='button',
                            style='margin-top: 0px; margin-bottom: 0px;',
                            v-if='document.id')
                            i.fa.fa-trash
      .pagination
        pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/company/documents/form/form.vue